/* LuckyPaws: one-click add from the cart drawer upsell row.
   Follows Dawn's own flow: POST to cart/add.js with the drawer sections,
   then let the cart-drawer component re-render itself. Plain JS. */
document.addEventListener('click', function (event) {
  var btn = event.target.closest('[data-lp-upsell-add]');
  if (!btn) return;
  event.preventDefault();
  btn.disabled = true;

  var drawer = document.querySelector('cart-drawer');
  var body = new FormData();
  body.append('id', btn.getAttribute('data-lp-upsell-add'));
  body.append('quantity', '1');
  body.append('sections', 'cart-drawer,cart-icon-bubble');
  body.append('sections_url', window.location.pathname);

  fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: body })
    .then(function (r) { return r.json(); })
    .then(function (state) {
      if (state.status) throw new Error(state.description || 'add failed');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(state);
      } else {
        window.location.reload();
      }
    })
    .catch(function () { window.location.reload(); });
});
